var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCapacitorDcBias = function SvgCapacitorDcBias(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 14,
    fill: "none",
    viewBox: "0 0 25 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5673E",
    d: "M24.183 6.423H14.42c.092-1.93.654-3.809 1.636-5.473a.577.577 0 1 0-.993-.587 13.04 13.04 0 0 0 0 13.274.577.577 0 1 0 .993-.587 11.9 11.9 0 0 1-1.636-5.473h9.763a.577.577 0 1 0 0-1.154M9.439.077a.577.577 0 0 0-.577.577v5.77H.817a.577.577 0 1 0 0 1.153h8.045v5.77a.577.577 0 0 0 1.154 0V.653A.577.577 0 0 0 9.44.077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5673E",
    d: "M4.487 4.564h.962v.962a.577.577 0 1 0 1.154 0v-.962h.961a.577.577 0 1 0 0-1.154h-.961V2.45a.577.577 0 0 0-1.154 0v.961h-.962a.577.577 0 1 0 0 1.154"
  })));
};
export { SvgCapacitorDcBias as ReactComponent };
export default "/_next/static/media/static/media/capacitor_dc_bias.7a4a35f84159ca36f5a870cce1a27cdfsvg";